import React from 'react';
import { useState, ReactElement } from 'react';
import Button from '../../../widget-ui-toolkit/Button';
import DateTimeScheduleInput from '../../../components/DateTimeScheduleInput/DateTimeScheduleInput';
import { CalendarViewProps } from './types';
import { trackEvent } from '../../../utils/eventTracking';
import FormattedMessage from '../../../widget-ui-toolkit/FormattedMessage';
import styles from './CalendarView.module.css';
import { SlotsAndUnavailability } from '../../../components/TimeScheduleInput/types';

const LOCALIZE_PREFIX = 'widget.booking.calendar';

const CalendarView = ({
  onSubmit,
  onCancel,
  slots,
  appointmentDateTime,
  bookingHorizonDays,
  showNurse,
  showDoctor,
  onNurseClick,
  onDoctorClick,
}: CalendarViewProps): ReactElement => {
  const [date, setDate] = useState(appointmentDateTime);
  const [isValidSlotSelected, setIsValidSlotSelected] = useState(true);

  const updateBooking = () => {
    onSubmit(date);
    trackEvent({ action: 'new-date-confirmed', label: date.toISOString() });
  };

  const handleChangeDate = (date: Date, isValidSlot: boolean) => {
    setDate(date);
    setIsValidSlotSelected(isValidSlot);
  };

  return (
    <>
      <DateTimeScheduleInput
        slots={slots}
        onChange={handleChangeDate}
        value={date}
        maxDaysEnabled={bookingHorizonDays}
        onDoctorClick={onDoctorClick}
        onNurseClick={onNurseClick}
        showNurse={showNurse}
        showDoctor={showDoctor}
      />
      <div className={styles.buttonWrapper}>
        <Button secondary onClick={onCancel}>
          <FormattedMessage id={`${LOCALIZE_PREFIX}.cancel_date_button`} />
        </Button>
        <div className={styles.buttonDivider} />
        <Button primary onClick={updateBooking} disabled={!isValidSlotSelected}>
          <FormattedMessage id={`${LOCALIZE_PREFIX}.confirm_date_button`} />
        </Button>
      </div>
    </>
  );
};

export default CalendarView;
